import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { MobileEditorialHeading } from "./mobile-editorial-heading";

export function MobileFaq() {
  const { t } = useTranslation();
  const faqs = t("faq.items", { returnObjects: true }) as { q: string; a: string }[];
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? faqs : faqs.slice(0, 3);
  return (
    <section id="faq" className="mob-surface-0 px-5 py-16 text-white">
      <div className="border-t border-white/10 pt-8">
        <MobileEditorialHeading index="06" eyebrow={t("faq.eyebrow")} title={t("faq.title")} />
      </div>
      <Accordion type="single" collapsible className="mt-6">
        {visible.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b mob-hairline">
            <AccordionTrigger className="py-4 text-left text-[15px] font-medium text-white hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-[14px] leading-relaxed text-white/65">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      {faqs.length > 3 && (
        <button onClick={() => setShowAll((v) => !v)} className="mob-tap mt-4 inline-flex h-10 items-center rounded-full border mob-hairline-strong px-4 text-[13px] font-medium text-white">
          {showAll ? "Mostra meno" : `Tutte le FAQ (${faqs.length})`}
        </button>
      )}
    </section>
  );
}

